/* Respect Shopify's visible draft-preview toolbar without hiding it.
   Live stores have no inset; browser chrome is handled by CSS dynamic viewport units. */
(() => {
  if (window.bfeCartLayoutReady) return;
  window.bfeCartLayoutReady = true;

  let toolbar;
  let frame;
  const update = () => {
    frame = null;
    const viewportHeight = window.innerHeight;
    const rect = toolbar?.getBoundingClientRect();
    const visible = toolbar && getComputedStyle(toolbar).visibility !== 'hidden';
    const inset = visible && rect.height > 0 && rect.top > viewportHeight / 2
      ? Math.max(0, Math.min(rect.bottom, viewportHeight) - rect.top)
      : 0;
    document.documentElement.style.setProperty('--bfe-cart-preview-inset', `${Math.ceil(inset)}px`);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const resizeObserver = new ResizeObserver(schedule);
  const attributeObserver = new MutationObserver(schedule);
  const findToolbar = () => {
    const next = document.getElementById('PBarNextFrameWrapper');
    if (next !== toolbar) {
      resizeObserver.disconnect();
      attributeObserver.disconnect();
      toolbar = next;
      if (toolbar) {
        resizeObserver.observe(toolbar);
        attributeObserver.observe(toolbar, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      }
    }
    schedule();
  };
  findToolbar();
  new MutationObserver(findToolbar).observe(document.body, { childList: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', findToolbar);
})();
